export const emptyFunction: EmptyFunction = () => {
  // This is intentional
};

export type EmptyFunction = () => void;
